/**
 * The instructions on a case: one field. Section 5 of the request of
 * 5 October 2026.
 *
 * There were two, the doctor's on the tray and the lab's own on the order
 * (section 9 of the request of 20 September 2026). The second went, and every
 * case that had text in both was merged into the one, each part under its own
 * heading, so nothing written was lost. `mergeInstructions` is that rule; the
 * API's migration runs the same one over the database.
 */

/** The longest a merged pair can be: 2,500 characters each and the two headings. */
export const INSTRUCTIONS_MAX = 5100;

export const INSTRUCTIONS_REFUSAL = {
  tooLong: 'Keep the instructions to 5,100 characters',
} as const;

export const DOCTOR_HEADING = "Doctor's instructions:";
export const LAB_HEADING = 'Lab instructions:';

/**
 * The two old fields as one. The doctor's alone is left exactly as it was. The
 * lab's alone goes under its heading, so what it was is still said. Both go
 * under a heading each, a blank line between them.
 */
export function mergeInstructions(
  doctor: string | null | undefined,
  lab: string | null | undefined,
): string {
  const first = (doctor ?? '').trim();
  const second = (lab ?? '').trim();

  if (second === '') return first;
  if (first === '') return `${LAB_HEADING}\n${second}`;
  return `${DOCTOR_HEADING}\n${first}\n\n${LAB_HEADING}\n${second}`;
}

/** What is wrong with the instructions as typed, or null when nothing is. */
export function instructionsRefusal(text: string): string | null {
  return text.trim().length > INSTRUCTIONS_MAX ? INSTRUCTIONS_REFUSAL.tooLong : null;
}
